import React, { Fragment } from "react";
import { useStore, useSelector } from "react-redux";
import { flatten } from "lodash-es";
import { Cartesian3, Color } from "cesium";
import {
  PointPrimitive,
  PolygonGraphics,
  PointPrimitiveCollection,
  Entity,
} from "resium";
import { generateVertexes } from "@/utils";

function PolygonLayer() {
  const { select } = useStore();
  const polygon = useSelector(select.layer.selectPolygon);
  let points, rectangle;
  if (polygon.length === 2) {
    const p = generateVertexes(polygon[0], polygon[1]);
    points = p.map((v, i) => {
      return (
        <PointPrimitive
          key={`point-${v[0]}-${v[1]}`}
          position={Cartesian3.fromDegrees(v[0], v[1])}
          pixelSize={4}
          color={Color.CHARTREUSE}
        />
      );
    });
    rectangle = (
      <PolygonGraphics
        hierarchy={Cartesian3.fromDegreesArray(flatten(p))}
        material={Color.GREEN.withAlpha(0.3)}
      />
    );
  } else {
    points = polygon.map((v, i) => {
      return (
        <PointPrimitive
          key={`point-${v[0]}-${v[1]}`}
          position={Cartesian3.fromDegrees(v[0], v[1])}
          pixelSize={4}
          color={Color.CHARTREUSE}
        />
      );
    });
  }
  return (
    <Fragment>
      <PointPrimitiveCollection>{points}</PointPrimitiveCollection>
      {rectangle && <Entity name="PolygonGraphics">{rectangle}</Entity>}
    </Fragment>
  );
}

export default PolygonLayer;
